import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getArticle, getArticleDescription } from '../../actions/dataActions'
import { setWeightModal, abortWeigh } from '../../modal/actions/modalActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';
import * as rl from '../../models/ReceiptLine';
import * as types from '../../constants/Types'
import { addReceiptLineWithOptionalParams } from '../../actions/receiptActions'

class WeighModal extends Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);

    }

    closeModal() {

        if (this.props.weighModal.weight >= 0) {
            const article = this.props.getArticle(this.props.weighModal.articleId);
            if (article !== null) {
                const articlePrice = (this.props.weighModal.weight / 1000) * article.SalesPrice;

                const rlParam = rl.Get();
                rlParam.ItemId = article.ArticleId;
                rlParam.LineType = types.ARTICLE_LINE;
                rlParam.Price = articlePrice;
                rlParam.Text = this.props.getArticleDescription(article);
                rlParam.Editable = true;

                const rlParamOptional = rl.GetOptional();
                rlParamOptional.Weight = this.props.weighModal.weight;

                this.props.addReceiptLineWithOptionalParams(rlParam, rlParamOptional);
            }
        } else {
            this.props.abortWeigh(this.props.weighModal.deviceId);
        }

        this.props.setWeightModal(false, 0, 0);
    }

    render() {
        const article = this.props.getArticle(this.props.weighModal.articleId);

        let articleDescription = '';
        let articleSalesPrice = 0;
        if (article !== null) {
            articleDescription = this.props.getArticleDescription(article);
            articleSalesPrice = article.SalesPrice;
        }

        let header = `Wegen ${articleDescription}`;
        let kgPrice = `Kiloprijs: ${articleSalesPrice.toFixed(2).replace('.', ',')}`;

        let message = this.props.weighModal.message;
        let buttonText = 'Afbreken';
        let price = '';
        let articlePrice = 0;
        if (this.props.weighModal.weight >= 0) {
            message = `Gewicht: ${this.props.weighModal.weight} gram`;
            buttonText = 'Toevoegen';

            articlePrice = (this.props.weighModal.weight / 1000) * articleSalesPrice;
            price = `Prijs: ${articlePrice.toFixed(2).replace('.', ',')}`;

        }

        return (
            <Modal className='paymentModal'                
                contentLabel=""
                isOpen={this.props.weighModal.show}
                style={properties.paymentModalStyle}
            >
                <div className="paymentModal_header">
                    <div className="header_top">
                        {header}
                    </div>
                </div>

                <div className="paymentModal_content">
                    {kgPrice}<br />
                    {message}<br />
                    <br />
                    {price}
                </div>
                <div className="paymentModal_footer">
                    <button className="btnCancel" onClick={this.closeModal} >
                        {buttonText}
                        <Ink />
                    </button>
                </div>
            </Modal>
        )
    }
}

WeighModal.propTypes = {
}

function mapStateToProps(state) {
    return {
        weighModal: state.modalState.weighModal,
        culture: state.layoutState.language.culture
    }
}

export default connect(mapStateToProps, {
    getArticle,
    getArticleDescription,
    setWeightModal,
    abortWeigh,
    addReceiptLineWithOptionalParams
})(WeighModal)


// WEBPACK FOOTER //
// src/modal/components/WeighModal.jsx